/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        primaryTitle: {
            color: '#222228',
            textAlign: "center",
            fontFamily: 'GilmerBold',
            fontSize: '29px'
        },
        customWidth: {
            borderRadius: theme.spacing(1.5),
            maxWidth: theme.spacing(87.5),
            paddingTop: theme.spacing(5),
            paddingBottom: theme.spacing(4)
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[200]
        },
        dialogContent: {
            paddingTop: `${theme.spacing(2)}px`
        },
        textInput: {
            width: "100%",
            '& .MuiInputBase-input': {
                fontSize: 14
            },
            '& .MuiOutlinedInput-root': {
                height: theme.spacing(6)
            },
            '& .MuiFormHelperText-contained': {
                marginRight: 0,
                minHeight: theme.spacing(3.75)
            }
        },
        textLabelWithAsterisk: {
            marginBottom: theme.spacing(1.5),
            marginTop: theme.spacing(-0.5),
            fontFamily: 'GilmerMedium',
            fontSize: '13px',
            color: '#1D2028',
            lineHeight: '24px'
        },
        asterisk: {
            color: 'red',
        },
        cancelBtn: {
            marginRight: theme.spacing(1),
            height: theme.spacing(5),
            fontSize: 13,
            fontFamily: 'GilmerMedium'
        },
        dialogBtn: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            fontSize: 13,
            fontFamily: 'GilmerMedium',
            '&:focus': {
                backgroundColor: 'none',
            }
        },
        messageBox: {
            '&.infoContainer': {
                width: '100%',
            }
        },
        shareInformationMessage: {
            fontSize: 14,
        },
        invalidEMail: {
            color: 'red'
        },
        emailChip: {
            ...theme.custom.applicationViewPage.tabs.overview.emailChipStyle,
            borderRadius: theme.spacing(0.7),
        },
        infoBannerText: {
            fontFamily: 'GilmerMedium',
        },
    })
);
